import React, { useState, useEffect } from "react";
// import CKEditor from "ckeditor4-react";
// import 'ckeditor4-react/ckeditor5-build-classic/build/translations/zh-cn.js'
import style from "./AnswerEditor.module.scss";
import { Button } from "antd";
import Config from "../../../../../config";
import Editor from "../../../../../components/Editor";

// CKEditor.editorUrl = '/ckeditor/ckeditor.js';

const EditorConfig = {
    height: 200,
    language: "zh-cn",
    filebrowserUploadUrl: `${Config.BaseUrl}teacher/file/upload`,
    filebrowserImageUploadUrl: `${Config.BaseUrl}teacher/file/upload`,
    uploadUrl: `${Config.BaseUrl}teacher/file/upload`
};

interface IAnswerEditorProps {
    title: string;
    tid: string;
    content: string;
    onSubmit: (content: string) => void;
}

export default function AnswerEditor({
    title,
    tid,
    content,
    onSubmit
}: IAnswerEditorProps) {
    let [data, setData] = useState(content);

    useEffect(() => {
        setData(content);
    }, [content]);

    const handleSubmit = () => {
        onSubmit(data);
    };

    return (
        <div className={style.root}>
            <h1 className={style.title}>回答问题：</h1>

            <div>
                {/*<CKEditor*/}
                {/*    config={EditorConfig}*/}
                {/*    onBeforeLoad={(CKEDITOR: any) => (CKEDITOR.disableAutoInline = true)}*/}
                {/*    onChange={( event: any ) => {setData(event.editor.getData())}}*/}
                {/*    data={data}*/}
                {/*/>*/}
                <Editor data={data} onChange={setData} />
            </div>

            <div className={style.footer}>
                <Button type="primary" size="large" onClick={handleSubmit}>
                    发布
                </Button>
            </div>
        </div>
    );
}
